import { api } from "#app/http/api";

export const fetchRecentSearches = async (): Promise<string[]> => {
  const response = await api.search.getRecentSearches.query();

  if (response.status !== 200) {
    throw new Error("Recent searches request failed");
  }

  return response.body.results;
};
